<template style="width: 100%;height: 100%;">
    <div v-if="modalVisible" class="container-modal">
        <span style="width: 800px; max-width: 800px; height: 100%;" class="modal-window" ref="my-modal" hide-footer title="">
            <div class="window-header">
               <h3 style="padding-left: 20px;">ОТЗЫВ О ПЕРЕВОЗЧИКЕ {{header}}</h3>
               <img v-on:click="hideModal()" class="modal-cancel" src="../assets/IMGS/SVG/cancel.svg" alt="cancel" style="padding-right: 20px; width:16px;height: 16px;">
            </div>
            <div class="modal-info" style=" width: 90%; justify-content: flex-start; align-items: flex-start; flex-direction: column;">
                <span style="display:flex; align-items: center;">
                <label style="font-weight: 600;  display:flex; margin-top: 15px; padding-right: 25px; width: min-content;" for="rate">Общая оценка:</label>
                <div class="star-rating">
                    <div class="star-rating__wrap">
                        <input class="star-rating__input" id="star-rating-5" type="radio" name="rating" value="5">
                        <label v-on:click="setStars(5)" class="star-rating__ico" for="star-rating-5" title="5 из 5 звезд"></label>
                        <input class="star-rating__input" id="star-rating-4" type="radio" name="rating" value="4">
                        <label v-on:click="setStars(4)" class="star-rating__ico" for="star-rating-4" title="4 из 5 звезд"></label>
                        <input class="star-rating__input" id="star-rating-3" type="radio" name="rating" value="3">
                        <label v-on:click="setStars(3)" class="star-rating__ico" for="star-rating-3" title="3 из 5 звезд"></label>
                        <input class="star-rating__input" id="star-rating-2" type="radio" name="rating" value="2">
                        <label v-on:click="setStars(2)" class="star-rating__ico" for="star-rating-2" title="2 из 5 звезд"></label>
                        <input class="star-rating__input" id="star-rating-1" type="radio" name="rating" value="1">
                        <label v-on:click="setStars(1)" class="star-rating__ico" for="star-rating-1" title="1 из 5 звезд"></label>
                    </div>
                </div>
                </span>
                <label style="font-weight: 600; padding-top: 50px;" for="comment">Комментарий</label>
                <textarea placeholder="Впечатления о перевозчике" style="border-radius:0; padding-left: 20px;  margin-top: 15px; resize: none; height: 185px; width: 85%;" class='forminput' id="comment"></textarea>
                <label style="padding-top: 20px;">Нажимая на кнопку Отправить я соглашаюсь с условиями пользования
                </label>
            </div>
            <div class="modal-do">
                <button class="ui-button ui-button--xl ui-button--grey" block v-on:click="hideModal()">Отменить</button>
                <button class="ui-button ui-button--xl ui-button--secondary" block v-on:click="hideModal(true)">Отправить</button>
            </div>
        </span>
    </div>
</template>
  
<script>
    export default {
        name: 'RateOrderWindow',
        props: {
            header: String,
            ratecallback: {
                type: Function,
                default() { return function(){} }
            },
            callback: {
                type: Function,
                default() { return function(){} }
            }
        },
        data() {
            return {
                modalVisible: true,
                type:'',
                rate: 0
            }
        },
        methods: {
            setStars(stars) {
                this.rate = stars
            },
            hideModal(doRateCallback) {
                var comment = document.getElementById("comment").value;
                this.modalVisible = false;
                if (doRateCallback) this.ratecallback(this.rate, comment);
                if (this.callback) this.callback();
            }
        }
    }
</script>

<style lang="css" scoped src="@/assets/css/modal.css"></style>
<style lang="css" scoped src="@/assets/css/dispatcher_orders.css"></style>
